import React from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    arrowBack: {
        cursor: 'pointer'
    },
    card: {
        maxWidth: 800,
        borderRadius: 12,
        margin: '1rem',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}))

const ArrowBack = ({ className, onClick }) => {
    const classes = useStyles();

    return (
        <span className={clsx(classes.arrowBack, className)} onClick={onClick}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.7915 7.00502H3.62148L8.50148 2.12502C8.89148 1.73502 8.89148 1.09502 8.50148 0.705022C8.31465 0.51777 8.061 0.412537 7.79648 0.412537C7.53197 0.412537 7.27832 0.51777 7.09148 0.705022L0.501484 7.29502C0.111484 7.68502 0.111484 8.31502 0.501484 8.70502L7.09148 15.295C7.48148 15.685 8.11148 15.685 8.50148 15.295C8.89148 14.905 8.89148 14.275 8.50148 13.885L3.62148 9.00502H14.7915C15.3415 9.00502 15.7915 8.55502 15.7915 8.00502C15.7915 7.45502 15.3415 7.00502 14.7915 7.00502Z" fill="#141414" />
            </svg>
        </span>

    )
}

export default ArrowBack;
